import { CATEGORIES_KEYS } from "./const";
import stepRegistry from "./stepRegistry";

import {
  CapitalGoods,
  CategoryBusinessTravel,
  CategoryDownstreamLeasedAssets,
  CategoryEmployeeCommuting,
  CategoryFranchise,
  CategoryInvestments,
  CategoryProcessingOfSoldProducts,
  CategoryUpstreamLeasedAssets,
  CategoryUseOfSoldProducts,
  DownstreamTransportationAndDistribution,
  FuelAndEnergyRelatedActivities,
  PurchasedGoodsAndServices,
  TreatmentOfSoldProducts,
  UpstreamTransportationAndDistribution,
  WasteGeneratedInOperations
} from "./components/Category";
import { ImportItemsButton } from "./components/ImportItemsButton";
import {
  capitalGoodsKeys,
  downstreamTransportationAndDistributionKeys,
  employeeCommutingKeys,
  organizationQuestionnaireKeys,
  purchasedGoodsAndServicesKeys,
  treatmentOfSoldProductsKeys,
  upstreamTransportationAndDistributionKeys,
  useDownloadCapitalGoodsTemplate,
  useDownloadDownstreamTransportationAndDistributionTemplate,
  useDownloadEmployeeCommutingTemplate,
  useDownloadPurchasedGoodsAndServicesTemplate,
  useDownloadTreatmentOfSoldProductsTemplate,
  useDownloadUpstreamTransportationAndDistributionTemplate,
  useDownloadUseOfSoldProductsTemplate,
  useDownloadWasteGeneratedInOperationsTemplate,
  useImportCapitalGoodsItems,
  useImportDownstreamTransportationAndDistributionItems,
  useImportEmployeeCommutingItems,
  useImportPurchasedProductItems,
  useImportTreatmentOfSoldProductsItems,
  useImportUpstreamTransportationAndDistributionItems,
  useImportUseOfSoldProducts,
  useImportWasteGeneratedInOperationsItems,
  wasteGeneratedInOperationsKeys
} from "../../../../hooks/query";
import {
  businessTravelKeys,
  useDownloadBusinessTravelTemplate,
  useImportBusinessTravelItems
} from "../../../../hooks/query/questionnaire/categories/business-travel";

stepRegistry.register(CATEGORIES_KEYS.purchasedGoodsAndServices, PurchasedGoodsAndServices,
  ImportItemsButton, {
    itemsKeys: purchasedGoodsAndServicesKeys,
    importItemsHook: useImportPurchasedProductItems,
    itemsType: "purchased-goods-and-services",
    downloadTemplate: useDownloadPurchasedGoodsAndServicesTemplate
  });
stepRegistry.register(CATEGORIES_KEYS.capitalGoods, CapitalGoods,
  ImportItemsButton, {
    itemsKeys: capitalGoodsKeys,
    importItemsHook: useImportCapitalGoodsItems,
    itemsType: "capital-goods",
    downloadTemplate: useDownloadCapitalGoodsTemplate
  });
stepRegistry.register(CATEGORIES_KEYS.fuelAndEnergyRelatedActivities, FuelAndEnergyRelatedActivities);
stepRegistry.register(CATEGORIES_KEYS.upstreamTransportationAndDistribution, UpstreamTransportationAndDistribution,
  ImportItemsButton, {
    itemsKeys: upstreamTransportationAndDistributionKeys,
    importItemsHook: useImportUpstreamTransportationAndDistributionItems,
    itemsType: "upstream-transportation-and-distribution",
    downloadTemplate: useDownloadUpstreamTransportationAndDistributionTemplate
  });
stepRegistry.register(CATEGORIES_KEYS.wasteGeneratedInOperations, WasteGeneratedInOperations,
  ImportItemsButton, {
    itemsKeys: wasteGeneratedInOperationsKeys,
    importItemsHook: useImportWasteGeneratedInOperationsItems,
    itemsType: "waste-generated-in-operations",
    downloadTemplate: useDownloadWasteGeneratedInOperationsTemplate
  });

stepRegistry.register(CATEGORIES_KEYS.businessTravel, CategoryBusinessTravel,
  ImportItemsButton, {
    itemsKeys: businessTravelKeys,
    importItemsHook: useImportBusinessTravelItems,
    itemsType: "business-travel",
    downloadTemplate: useDownloadBusinessTravelTemplate
  });
stepRegistry.register(CATEGORIES_KEYS.downstreamLeasedAssets, CategoryDownstreamLeasedAssets);
stepRegistry.register(CATEGORIES_KEYS.downstreamTransportationAndDistribution, DownstreamTransportationAndDistribution,
  ImportItemsButton, {
    itemsKeys: downstreamTransportationAndDistributionKeys,
    importItemsHook: useImportDownstreamTransportationAndDistributionItems,
    itemsType: "downstream-transportation-and-distribution",
    downloadTemplate: useDownloadDownstreamTransportationAndDistributionTemplate
  });
stepRegistry.register(CATEGORIES_KEYS.employeeCommuting, CategoryEmployeeCommuting,
  ImportItemsButton, {
    itemsKeys: employeeCommutingKeys,
    importItemsHook: useImportEmployeeCommutingItems,
    itemsType: "employee-commuting",
    downloadTemplate: useDownloadEmployeeCommutingTemplate
  });
stepRegistry.register(CATEGORIES_KEYS.franchises, CategoryFranchise);
stepRegistry.register(CATEGORIES_KEYS.investments, CategoryInvestments);
stepRegistry.register(CATEGORIES_KEYS.processingOfSoldProducts, CategoryProcessingOfSoldProducts);
stepRegistry.register(CATEGORIES_KEYS.upstreamLeasedAssets, CategoryUpstreamLeasedAssets);
stepRegistry.register(CATEGORIES_KEYS.useOfSoldProducts, CategoryUseOfSoldProducts, ImportItemsButton, {
  itemsKeys: organizationQuestionnaireKeys,
  importItemsHook: useImportUseOfSoldProducts,
  itemsType: "use-of-sold-products",
  downloadTemplate: useDownloadUseOfSoldProductsTemplate
});
stepRegistry.register(CATEGORIES_KEYS.treatmentOfSoldProducts, TreatmentOfSoldProducts, ImportItemsButton, {
  itemsKeys: treatmentOfSoldProductsKeys,
  importItemsHook: useImportTreatmentOfSoldProductsItems,
  itemsType: "treatment-of-sold-products",
  downloadTemplate: useDownloadTreatmentOfSoldProductsTemplate
});

export { default as CategoryQuestionnaire } from "./CategoryQuestionnaire";
